import type {
  ScrollToDateOptions,
  VirtualReservationListHandle,
} from "@/pages/ReservationPage/components/VirtualReservationList/VirtualReservationList";
import type { RefObject } from "react";
import { createContext } from "react";

type ReservationUIContextValue = {
  listRef: RefObject<VirtualReservationListHandle>;
  scrollToDate: (date: string, options?: ScrollToDateOptions) => void;
  calendarMonth: Date;
  setCalendarMonth: (month: Date) => void;
  isMobileCalendarOpen: boolean;
  openMobileCalendar: () => void;
  closeMobileCalendar: () => void;
  setMobileCalendarOpen: (open: boolean) => void;
};

export const ReservationUIContext =
  createContext<ReservationUIContextValue | null>(null);
